import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee999e34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CustomerChannelStatistics" }
const _hoisted_2 = { class: "statistics" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import dayjs from 'dayjs'
import {downloadData, getListData} from "@/service/main/system";
import {ref} from "vue";
import {queryDrainageSummaryStatistics} from "@/service/main/live/statitiscal";
import {modalConfig} from './config/modal.config'
import PageModal from "@/components/PageModal.vue";
import {ElLoading} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerChannelStatistics',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'channelName')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'thirdParty')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
  const thirdPartyModal = modalConfig.formItems.find(item => item.field === 'thirdParty')
  thirdPartyModal!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const queryParam = {
  cfddFlag: false,
  forceRefresh: false,
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const resetCb = () => {
  getStatistics(queryParam)
  return queryParam
}
const statistics = ref({
  resourcesCount: '--',
  repeatRate: '--',
  deleteRate: '--',
  totalDeleteRate: '--',
  invalidNum: '--',
  thCount: '--',
  // notPreciseCount: '--',
  openRate: '--',
  lookRate: '--',
  dealCount: '--',
  monthConversionRate: '--',
  lastMonthConversionRate: '--',
  accConversionRate: '--'
})

const getStatistics = async (item: any) => {
  statistics.value = await queryDrainageSummaryStatistics(item)
}
getStatistics(queryParam)

const searchCb = async (item: any) => {
  statistics.value = {
    resourcesCount: '--',
    repeatRate: '--',
    deleteRate: '--',
    totalDeleteRate: '--',
    invalidNum: '--',
    thCount: '--',
    // notPreciseCount: '--',
    openRate: '--',
    lookRate: '--',
    dealCount: '--',
    monthConversionRate: '--',
    lastMonthConversionRate: '--',
    accConversionRate: '--'
  }
  await getStatistics(item)
}

const defaultInfo = ref({})
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const modalTitle = ref('统计条件')
const handleDailyExportClick = () => {
  pageModalRef.value.dialogVisible = true
  pageModalRef.value.isBatch = true
}

const handleSubmitClick = async (formData: any) => {
  try {
    const loadingInstance = ElLoading.service({
      lock: true,
      text: '数据下载中...',
      background: 'rgba(0,0,0,0.5)'
    });
    await downloadData(
      '/main/drainageStatistics/exportDaily',
      {
        ...formData
      },
      'blob'
    ).then((res) => {
      loadingInstance.close()
      const blob = new Blob([res], {
        type: 'application/octet-stream'
      })
      const down = document.createElement('a')
      down.download = '每日数据统计.xlsx'
      down.style.display = 'none'
      down.href = URL.createObjectURL(blob)
      document.body.appendChild(down)
      down.click()
      URL.revokeObjectURL(down.href)
      document.body.removeChild(down)
    })
    pageModalRef.value.dialogVisible = false
    await store.dispatch('system/getPageListAction', {
      pageName: 'customerChannelStatistics',
      queryInfo: store.state.system.queryInfo
    })
  } finally {
    pageModalRef.value.confirmLoading = false
  }
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb, searchCb)
const lastForceRefresh = ref(queryParam.forceRefresh)
const handleSearchFormChange = (formData: any) => {
  const forceRefresh = formData.forceRefresh === true
  if (forceRefresh && !lastForceRefresh.value) {
    handleSearchClick(formData)
  }
  lastForceRefresh.value = forceRefresh
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onChange: handleSearchFormChange
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("资源数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.resourcesCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重复率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.repeatRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("24小时删除率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.deleteRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("累计删除率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.totalDeleteRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重叠数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.invalidNum), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("同行数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.thCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("开口率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.openRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("看课率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.lookRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("成交资源数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.dealCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("当月转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.monthConversionRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("上月转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.lastMonthConversionRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("累积转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.accConversionRate) + "%", 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customerChannelStatistics",
      downFilename: "渠道资源相关数据统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onDailyExportClick: handleDailyExportClick,
      onSortChange: handleSortChange
    }, {
      repeatRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.repeatRate) + "%", 1)
      ]),
      deleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.deleteRate) + "%", 1)
      ]),
      totalDeleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.totalDeleteRate) + "%", 1)
      ]),
      openRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.openRate) + "%", 1)
      ]),
      lookRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.lookRate) + "%", 1)
      ]),
      monthConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.monthConversionRate) + "%", 1)
      ]),
      lastMonthConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.lastMonthConversionRate) + "%", 1)
      ]),
      accConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.accConversionRate) + "%", 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: defaultInfo.value,
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "drainageStatistics",
      onUpdateBatchData: handleSubmitClick
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})